import type { ReactNode } from 'react';
import React, { useCallback } from 'react';
import type { MessageDescriptor } from 'react-intl';
import { useIntl } from 'react-intl';

import { Anchor } from '@atlaskit/primitives/compiled';

import type {
	FlagType,
	FlagsStateContainer,
} from '@confluence/flags/entry-points/FlagsStateContainer.ts';

type IssueCreateTriggerFlagPayload = {
	issueKey: string;
	link: string;
	summary: string;
};

export const useTriggerFlagIssueCreated = (flags: FlagsStateContainer) => {
	const { formatMessage } = useIntl();

	return useCallback(
		(payload: IssueCreateTriggerFlagPayload, flagType: FlagType, message: MessageDescriptor) => {
			void flags.showFlag({
				type: flagType,
				title: formatMessage(message, {
					issueKey: payload?.issueKey,
					issueSummary: payload?.summary,
					link: (chunks: ReactNode[]) => (
						<Anchor href={payload?.link} target="_blank">
							{chunks}
						</Anchor>
					),
				}),
				close: 'auto',
			});
		},
		[flags, formatMessage],
	);
};
